import Add16 from '@carbon/icons-react/es/add/16';
import Close16 from '@carbon/icons-react/es/close/16';
import { Form } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Text } from '../criteria/components';
import { FilterableField } from '../fields';

export const Row = styled.div`
  display: flex;
  flex: 1 0 100%;
  align-items: center;
  margin-bottom: var(--spacing-04);
`;

export const Box = styled.div`
  min-width: 480px;
  display: flex;
  flex-direction: column;

  /** TODO: Move out of here @artfuldev */
  .ant-select-arrow {
    right: var(--spacing-05);
  }

  .ant-select {
    min-width: 120px;
    max-width: 240px;
  }

  .ant-select.ant-select-selection-item {
    padding: var(--spacing-03) var(--layout-01);
  }

  .ant-form-item-control-input {
    height: 40px;
  }

  .ozone-select__menu {
    z-index: 2;
  }
`;

export const AddFilterButton = styled(Button).attrs({
  size: 'small',
  type: 'link',
  icon: <Add16 />,
  iconPlacement: 'right',
})`
  align-self: flex-start;
  margin-left: calc(-1 * var(--spacing-03));
`;

export const FilterView: FC<{ field: FilterableField }> = ({
  field,
  children,
}) => (
  <Row>
    <Form layout="inline">
      <Form.Item>
        <Button
          type="text"
          shape="circle"
          size="small"
          icon={<Close16 />}
          style={{ visibility: 'hidden' }}
        />
      </Form.Item>
      <Form.Item>
        <Text>{field.fieldLabel}</Text>
      </Form.Item>
      <Form.Item data-cy={`select.fields.${field.fieldName}`}>
        {children}
      </Form.Item>
    </Form>
  </Row>
);

export const Switch = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export const Header = styled(Row)`
  min-width: 500px;
`;

export const AdvancedBoxWrapper = styled.div`
  max-height: 30vh;
  overflow-y: scroll;
  overflow-x: hidden;
`;
